module.exports = __webpack_public_path__ + "static/media/supplierIconDark.3a6d36ea.svg";